require('aws-sdk/lib/node_loader');
var AWS = require('aws-sdk/lib/core');
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;
const SERVICE_NAME = "smworkfloworchestrationservicelambda"

apiLoader.services[SERVICE_NAME] = {};
SMWorkflowOrchestrationServiceLambda = Service.defineService(SERVICE_NAME, ['2018-05-10']);
Object.defineProperty(apiLoader.services[SERVICE_NAME], '2018-05-10', {
    get: function get() {
        var model = require('./c2j.json');
        return model;
    },
    enumerable: true,
    configurable: true
});

module.exports = SMWorkflowOrchestrationServiceLambda;